import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/* Shown when a signed-in non-admin hits an /admin route. Always offers a way out. */
export default function AdminAccessDenied({ next = "/admin" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const switchAccount = async () => {
    setBusy(true);
    await logout();
    navigate(`/login?next=${encodeURIComponent(next)}`, { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5 bg-[#070707] px-6 text-center"
         data-testid="admin-denied">
      <p className="font-mono text-[10px] tracking-[0.4em] text-red-500/90">ACCESS RESTRICTED</p>
      <p className="font-serif text-2xl md:text-3xl text-white/70">This console requires administrator access.</p>
      {user?.email && (
        <p className="font-mono text-[10px] tracking-[0.2em] text-white/35" data-testid="admin-denied-current-user">
          SIGNED IN AS {user.email.toUpperCase()}
        </p>
      )}
      <button onClick={switchAccount} disabled={busy} data-testid="admin-denied-switch-account"
              className="mt-2 px-7 py-3 bg-gold text-black font-mono text-[10px] tracking-[0.25em] transition-opacity hover:opacity-85 disabled:opacity-50">
        {busy ? "SIGNING OUT…" : "SIGN IN AS ADMINISTRATOR"}
      </button>
      <Link to="/" data-testid="admin-denied-back"
            className="font-mono text-[10px] tracking-[0.25em] text-gold hover:text-white transition-colors">
        ← BACK TO THE SITE
      </Link>
    </div>
  );
}
